module.exports = __webpack_public_path__ + "static/img/hotel.ad02ddf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/hotel.gif
// module id = S24A
// module chunks = 1